import api from "../axiosIntercepture";

const BASE = "rateslab";

export const createRateSlab = async (payload) => {
  try {
    const response = await api.post(`${BASE}/create`, payload);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error("Error creating rate slab:", err);
    throw err?.response?.data?.message || "Failed to create rate slab";
  }
};

export const getAllRateSlabs = async () => {
  try {
    const response = await api.get(`${BASE}/list`);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? [];
  } catch (err) {
    console.error("Error fetching rate slabs:", err);
    throw err?.response?.data?.message || "Failed to fetch rate slabs";
  }
};

export const getRateSlabById = async (id) => {
  try {
    const response = await api.get(`${BASE}/${id}`);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? null;
  } catch (err) {
    console.error("Error fetching rate slab:", err);
    throw err?.response?.data?.message || "Failed to fetch rate slab";
  }
};

export const updateRateSlab = async (id, payload) => {
  try {
    const response = await api.put(`${BASE}/update/${id}`, payload);
    if (response.data?.success && response.data?.data) {
      return response.data.data;
    }
    return response.data?.data ?? response.data;
  } catch (err) {
    console.error("Error updating rate slab:", err);
    throw err?.response?.data?.message || "Failed to update rate slab";
  }
};

export const deleteRateSlab = async (id) => {
  try {
    const response = await api.delete(`${BASE}/delete/${id}`);
    if (response.data?.success) {
      return response.data.data;
    }
    return response.data;
  } catch (err) {
    console.error("Error deleting rate slab:", err);
    throw err?.response?.data?.message || "Failed to delete rate slab";
  }
};
